ProfileValidation = {
  mixins: [vuelidate.validationMixin],
  validations() {
    //console.log(arguments, this);
    return {
      info_required:
        this.profile.type === 'P'
          ? [
              'profile.first_name',
              'profile.last_name',
              'profile.location',
              'profile.birth_date',
              'profile.description',
            ]
          : ['profile.first_name', 'profile.location', 'profile.description'],
      info_recommended: [],
      experience_required:
        this.profile.type === 'P'
          ? ['profile.studies', 'profile.languages', 'profile.activities']
          : ['profile.languages', 'profile.activities'],
      experience_recommended: ['profile.experience'],
      availability_required: ['profile.schedules'],
      availability_recommended: [],
      alerts_required: ['profile.alerts'],
      alerts_recommended: [],
      profile: {
        //info
        first_name: { required: validators.required },
        last_name: { required: validators.required },
        location: { required: validators.required },
        birth_date: {
          required: validators.required,
          canWork: (value) => {
            const bd = new Date(value);
            const min = new Date();
            min.setFullYear(min.getFullYear() - 16);
            return bd.getTime() <= min.getTime();
          },
        },
        description: {
          required: validators.required,
          short: validators.minLength(50),
        },
        //phone: { valid: validators.url, },
        linkedin: {
          valid: validators.url,
        },
        url: {
          valid: validators.url,
        },
        twitter: {
          valid: function (value, record) {
            if (!value) return true;
            return !!value.match(/^\@[\w]+$/);
          },
        },
        //experience
        experience: {
          required: validators.required,
          short: validators.minLength(50),
        },
        education: {
          required: validators.required,
          short: validators.minLength(25),
        },
        studies: { required: validators.required },
        languages: { required: validators.required },
        activities: { required: validators.required },
        //availability
        schedules: { valid: validators.required },
        //alerts
        alerts: { valid: validators.required },
      },
    };
  },
};
